// extracted by mini-css-extract-plugin
export default {"block":"Toast_block__uGnx7"};